const RATE_RULE_FIELD_SEPARATOR = '~'
const RATE_RULE_MIN_FIELD_COUNT = 9
const RATE_RULE_RATE_TYPE_INDEX = 4
const RATE_RULE_PRICE_DELIVERY_INDEX = 5
const CUG_RATE_TYPE = 'C'
const B2C_RATE_TYPE = 'B'
const LIVE_PRICE_DELIVERY = 'L'

// Compact GHA rule IDs keep field order stable and may append fields over time.
function compactRateRuleField(ruleId: string, index: number): string | undefined {
  const fields = ruleId.split(RATE_RULE_FIELD_SEPARATOR)
  if (fields.length < RATE_RULE_MIN_FIELD_COUNT) return undefined

  return fields[index]?.toUpperCase()
}

// rate_type is the fifth field: C = CUG, B = B2C.
export function isEligibleMetasearchCugRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  return compactRateRuleField(ruleId, RATE_RULE_RATE_TYPE_INDEX) === CUG_RATE_TYPE
}

export function isB2cMetasearchRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  return compactRateRuleField(ruleId, RATE_RULE_RATE_TYPE_INDEX) === B2C_RATE_TYPE
}

// price_delivery_method is the sixth compact field: L = live, P = pull.
export function isLiveMetasearchRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  return compactRateRuleField(ruleId, RATE_RULE_PRICE_DELIVERY_INDEX) === LIVE_PRICE_DELIVERY
}
